export default {
  attachmentItemComponent: 'attachment-item',
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: true,
  allowMediaInserter: false,
  textFormatter: true,
  allowFilePaste: false,
  allowUploads: true,
  allowMention: false,
  allowAlignment: false,
  allowAttachments: false,
  allowAttribute: true,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowMarkdownHeadings: true,
  allowMarker: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: true,
  allowButton: false,
  allowVideo: true,
  allowSocial: false,
  allowCode: true,
  allowHtml: false,
  allowEmoji: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: true,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: true,
  // Convert markdown links to anchors
  markdownInlineCode: true,
  autoFocusTopLeft: true,
  allowedImageTypes: ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'],
  allowedFileTypes: ['*'],
  recoverErrors: true,
  allowRtl: false,
  stripEmptyTrailingBlocks: false
};